module.exports = __webpack_public_path__ + "save-template.svg?950432c8b73e8f7ac3547484d4b36fb8";